import React from "react";
import { Button } from "./Button";
import { color_red_default, color_white, color_transparent } from "../../../constants/colors";

export const ModalRedDefaultButton = ({ children, onClick, width = "100%", height = 40, ...props }) => {
    return (
        <Button
            outline={false}
            type="submit"
            width={width}
            height={height}
            backgroundColor={color_red_default}
            color={color_white}
            borderColor={color_transparent}
            fontSize={16}
            onClick={onClick}
            style={{
                color: color_white,
                border: "none",
                padding: "10px 20px",
                cursor: "pointer",
                fontWeight: 500,
                fontFamily: "Onest",
            }}
            {...props}
        >
            {children}
        </Button>
    );
};